import {h, Fragment} from "preact"
import { useState } from "preact/hooks"
import { useAppStateSelector } from "@nosto/preact"
import Sidebar from "./Sidebar"
import Toolbar from "./Toolbar"
import { GridProvider } from "./GridContext"

/**
 * ContentWrapper takes a function to render non-empty results in the content area.
 * On loading the Loader is used and for empty results the NoResults component is used.
 */
function ContentWrapper({ type, children }) {
    const { foundProducts, loading, response } = useAppStateSelector(state => ({
        foundProducts: state.response.products?.total > 0,
        loading: state.loading,
        response: state.response
    }))
    const [filtersHidden, setFiltersHidden] = useState(false)

    const toggleFilters = () => {
        setFiltersHidden(prev => !prev)
    }

    const settings = window.plpSettings || {};

    return (
        <GridProvider>
            <div className={`w-full page-width page-width--wide ${filtersHidden ? "hide-filters" : ""}`} data-nosto-element={type}>
                
                {settings.subcategories && (
                    <div className="mobile-subcategories">
                        <select
                            class="ns-selection-dropdown-menu ns-text-align-left ns-selection-dropdown-subcategories"
                            onChange={(e) => {
                            const selectedHandle = e.target.value;
                            if (selectedHandle) {
                                window.location.href = `/collections/${selectedHandle}`;
                            }
                            }}
                        >
                            <option value="">{settings.title}</option>
                            {settings.subcategories.map((item) => (
                            <option key={item.handle} value={item.handle}>
                                {item.title}
                            </option>
                            ))}
                        </select>
                    </div>
                )}
                
   
                {foundProducts && (
                    <div className="toolbar-wrap">
                        <div class="filter-wrap">
                            <button
                                className="ns-hide-filters-btn"
                                onClick={toggleFilters}
                                aria-label={filtersHidden ? "Filter" : "Hide filter"}
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M8.41465 7C8.20873 7.5826 7.65311 8 7 8C6.34689 8 5.79127 7.5826 5.58535 7C5.53008 6.84361 5.5 6.67532 5.5 6.5C5.5 6.32468 5.53008 6.15639 5.58535 6C5.79127 5.4174 6.34689 5 7 5C7.65311 5 8.20873 5.4174 8.41465 6C8.46992 6.15639 8.5 6.32468 8.5 6.5C8.5 6.67532 8.46992 6.84361 8.41465 7ZM9.44999 6C9.21836 4.85888 8.20948 4 7 4C5.79052 4 4.78164 4.85888 4.55001 6H3V7H4.55001C4.78164 8.14112 5.79052 9 7 9C8.20948 9 9.21836 8.14112 9.44999 7H17V6H9.44999ZM11.5854 14C11.7913 14.5826 12.3469 15 13 15C13.6531 15 14.2087 14.5826 14.4146 14C14.4699 13.8436 14.5 13.6753 14.5 13.5C14.5 13.3247 14.4699 13.1564 14.4146 13C14.2087 12.4174 13.6531 12 13 12C12.3469 12 11.7913 12.4174 11.5854 13C11.5301 13.1564 11.5 13.3247 11.5 13.5C11.5 13.6753 11.5301 13.8436 11.5854 14ZM10.55 13C10.7816 11.8589 11.7905 11 13 11C14.2095 11 15.2184 11.8589 15.45 13H17V14H15.45C15.2184 15.1411 14.2095 16 13 16C11.7905 16 10.7816 15.1411 10.55 14H3V13H10.55Z" fill="#F4F4F4"/>
                                </svg>
                                {filtersHidden ? "Filter" : "Hide Filter"}
                            </button>
                            <span>({response.products?.total})</span>
                        </div>
                        {settings.subcategories && (
                            <select
                                class="ns-selection-dropdown-menu ns-text-align-left ns-selection-dropdown-subcategories"
                                onChange={(e) => {
                                const selectedHandle = e.target.value;
                                if (selectedHandle) {
                                    window.location.href = `/collections/${selectedHandle}`;
                                }
                                }}
                            >
                                <option value="">{settings.title}</option>
                                {settings.subcategories.map((item) => (
                                <option key={item.handle} value={item.handle}>
                                    {item.title}
                                </option>
                                ))}
                            </select>
                        )}
                        <Toolbar />
                    </div>
                )}
                <div className="content-wrap">
                    {foundProducts && <Sidebar />}
                    <div
                        className="ns-d-block ns-d-md-inline ns-w-100 ns-border-box ns-p-0"
                        style={{ position: loading ? "relative" : "initial" }}
                    >
                        {children({ loading, foundProducts })}
                    </div>
                </div>
            </div>
        </GridProvider>
    )
}

export function wrapContent(type, Component) {
    return () => <ContentWrapper type={type}>{Component}</ContentWrapper>
}